<template>
    <div v-if="special && contentstream">
        <router-link
            :to="'/dashboard/special-report/' + contentstream.id"
            class="w-full flex flex-row justify-between items-center gap-2 px-4 py-2 rounded-xl hover:scale-y-105 duration-300 bg-dashboard-primary"
        >
            <div class="flex flex-row gap-2">
                <div class="text-xs">
                    <small v-if="contentstream?.title" class="text-xxs">
                        {{ $translate(contentstream?.title) }}
                    </small>
                    <small class="block text-xxs text-dashboard-primary-grey">
                        {{ $translate(contentstream?.contentstreamType?.title) }}
                    </small>
                    <small class="block text-xxs text-dashboard-primary-grey">
                        {{ formatDateByRegion($moment(contentstream?.published_at)) }}
                    </small>
                </div>
            </div>
        </router-link>
    </div>
    <div
        v-else
        v-if="contentstream?.product"
        :key="reloadKey"
        class="flex flex-row justify-between items-center gap-2 px-4 py-2 rounded-xl hover:scale-y-105 duration-300"
        :class="editMode ? 'odd:opacity-40 bg-dashboard-primary' : 'shadow-md'"
        :style="!editMode ? { backgroundColor: getBackgroundColor(contentstream) } : {}"
    >
        <router-link :to="getPath(contentstream)" class="w-full">
            <div class="flex flex-row gap-2">
                <i v-if="editMode" :src="contentstream.product.image" class="w-[40px] h-[40px] rounded-xl bg-white fill-white text-white flex-none" />
                <img v-else :src="contentstream.product.image.replace('.png', '-gradient.png')" class="w-[50px] object-contain" />
                <div class="text-xs">
                    <strong v-if="contentstream?.product">
                        {{ $translate(contentstream.product.name) }}
                    </strong>
                    <br />
                    <small v-if="contentstream.title && contentstream.title.de !== contentstream?.product?.name.de" class="text-xxs">
                        {{ $translate(contentstream.title) }}
                    </small>
                    <small class="block text-xxs text-dashboard-primary-grey">
                        {{ $translate(contentstream.contentstreamType.title) }}
                    </small>
                    <small class="block text-xxs text-dashboard-primary-grey">
                        {{ formatDateByRegion($moment(contentstream.published_at)) }}
                    </small>
                </div>
            </div>
        </router-link>

        <span
            class="rounded-xl p-2 cursor-pointer hover:scale-105 duration-300 items-center"
            @click="!editMode && toggleFavoriteReadStatus(contentstream)"
            :class="editMode ? 'bg-white' : 'bg-dashboard-primary'"
        >
            <i v-if="contentstream.read_status?.is_favorite" class="fi fi-sr-bookmark flex" :class="{ invisible: editMode }"></i>
            <i v-else class="fi fi-rr-bookmark flex" :class="{ invisible: editMode }"></i>
        </span>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { formatDateByRegion, getBackgroundColor } from '../../helpers.js';
import { useStore } from 'vuex';

const props = defineProps(['contentstream', 'editMode', 'special']);
const reloadKey = ref(0);
let analysesFilterQuery = ref('Schriftlich');
const store = useStore();
const user = ref(store.getters['user/get']);

const getPath = (contentstream) => {
    if (analysesFilterQuery === 'Sondernachrichten') {
        return '/dashboard/markets-analysis/' + contentstream.id;
    } else if (contentstream.contentstreamType?.name && contentstream.contentstreamType?.name === 'webinar') {
        return '/dashboard/markets-videoanalysis/' + contentstream.id;
    } else {
        return '/dashboard/markets-analysis/' + contentstream.id;
    }
};

const toggleFavoriteReadStatus = (contentstream) => {
    // Determine the target state
    const contentstreamFavoriteTarget = contentstream.read_status === null ? true : !contentstream.read_status.is_favorite;
    reloadKey.value++;

    // Update the state in the backend/DB via Vuex Dispatch
    if (contentstream.read_status === null) {
        contentstream.read_status = { is_favorite: true };
        store.dispatch('contentstream_user/init', {
            contentstreamId: contentstream.id,
            isFavorite: true
        });
    } else {
        contentstream.read_status.is_favorite = contentstreamFavoriteTarget;
        store.dispatch('contentstream_user/update', {
            userId: user.value.id,
            contentstreamId: contentstream.id,
            isFavorite: contentstreamFavoriteTarget
        });
    }
};
</script>
